import { createFileRoute } from '@tanstack/react-router';
import { VendorRegister } from '@/components/company/payments/vendor-register';

export const Route = createFileRoute('/(app)/company/payments/vendor-register')({
	component: VendorRegisterRoute,
});

function VendorRegisterRoute() {
	return <VendorRegister />;
}
